<template>
    <div class="bg-[#e8e8e8] py-8">
        <div class="flex flex-col items-center p-4">
            <h1 class="text-xl text-center font-bold">¿DE VIAJE?</h1>
            <div class="flex items-center gap-2">
                <img src="/flags/icon_world.png" alt="World Icon" class="w-6 h-6" />
                <p>DESCUBRE COLUMBIA HIKE SOCIETY EN OTROS PAÍSES:</p>
            </div>
            <hr class="my-2 w-[70%] border-black justify-center border-t-1" />
        </div>
        <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4  px-16 gap-8 md:gap-4 lg:gap-4">
            <!-- LATAM  1 -->
            <div>
                <h2 class="font-bold text-lg mb-4">LATAM</h2>
                <div class="space-y-3">
                    <div v-for="country in latamCol1" :key="country.name" class="flex items-center gap-3">
                        <img :src="country.flag" :alt="country.name" class="w-9 h-9 rounded-full object-cover" />
                        <a :href="country.link" target="_blank" class="hover:underline" rel="noopener noreferrer">
                        {{ country.name }}
                        </a>
                    </div>
                </div>
            </div>

            <!-- LATAM 2 -->
            <div>
                <h2 class="font-bold text-lg mb-4 invisible">LATAM</h2>
                <div class="space-y-3">
                    <div v-for="country in latamCol2" :key="country.name" class="flex items-center gap-3">
                        <img :src="country.flag" :alt="country.name" class="w-9 h-9 rounded-full object-cover" />
                       <a :href="country.link" target="_blank" class="hover:underline" rel="noopener noreferrer">
                        {{ country.name }}
                        </a>
                    </div>
                </div>
            </div>

            <!-- APAC -->
            <div>
                <h2 class="font-bold text-lg">APAC</h2>
                <div class="space-y-3">
                    <div v-for="country in apac" :key="country.name" class="flex items-center gap-3">
                        <img :src="country.flag" :alt="country.name" class="w-9 h-9 rounded-full object-cover" />
                        <a :href="country.link" target="_blank" class="hover:underline" rel="noopener noreferrer">
                        {{ country.name }}
                        </a>
                    </div>
                </div>
            </div>

            <!-- EMEA Column -->
            <div>
                <h2 class="font-bold text-lg mb-4">EMEA</h2>
                <div class="space-y-3">
                    <div v-for="country in emea" :key="country.name" class="flex items-center gap-3">
                        <img :src="country.flag" :alt="country.name" class="w-9 h-9 rounded-full object-cover" />
                        <a :href="country.link" target="_blank" class="hover:underline" rel="noopener noreferrer text-sm">
                        {{ country.name }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const latamCol1 = ref([
    { name: 'Bolivia', flag: '/flags/bolivia.png', link: 'https://columbia.bo/columbia-hike-society' },
    { name: 'Brazil', flag: '/flags/brazil.png', link: 'https://www.columbiasportswear.com.br/columbia-hike-society' },
    { name: 'Chile', flag: '/flags/chile.png', link: 'https://www.columbiachile.cl/columbia-hike-society?srsltid=AfmBOooxz1r_VTa__nrr7msI5_BymHfD-QwXxmkd9bCoK-M3wyor6GXf' },
    { name: 'Colombia', flag: '/flags/colombia.png', link: 'https://www.columbia.com.co/eventos-columbia?map=productClusternames' },
    { name: 'Costa Rica', flag: '/flags/costa_rica.png', link: 'https://hikesocietycam.com/' },
    { name: 'Ecuador', flag: '/flags/ecuador.png', link:'https://columbiasportswear.ec/columbia-hike-society' },
]);

const latamCol2 = ref([
    { name: 'Guatemala', flag: '/flags/guatemala.png', link:'https://hikesocietycam.com/' },
    { name: 'Mexico', flag: '/flags/mexico.png', link: 'https://www.columbia.mx/pages/hikesocietymx' },
    { name: 'Panama', flag: '/flags/panama.png', link:'https://hikesocietycam.com/' },
    { name: 'Paraguay', flag: '/flags/paraguay.png', link:'https://www.columbiasportswear.com.py/columbia-hike-society' },
    { name: 'Perú', flag: '/flags/peru.png', link:'https://www.columbia.pe/hike-society' },
    //esta no esta aun
    // { name: 'Uruguay', flag: '/src/assets/flags/uruguay.png' }, 
]);

const apac = ref([
    //{ name: 'Indonesia', flag: '/flags/indonesia.png', link:'https://id.columbiahikesociety.app/' },
    { name: 'Philippines', flag: '/flags/philippines.png', link:'https://columbiasportswear.ph/pages/columbia-hike-society' },
    { name: 'Taiwán', flag: '/flags/republic_of_china.png', link:'https://www.columbiasportswear.com.tw/page/HikeSociety' },
    { name: 'Thailand', flag: '/flags/thailand.png', link:'https://www.columbia.co.th/pages/hike-society' },
    { name: 'Vietnam', flag: '/flags/vietnam.png', link:'https://columbia.vn/pages/columbia-hike-society-event' },
    { name: 'Mongolia', flag: '/flags/mongolia.png', link:'https://www.columbia.mn/hike-society' },
    { name: 'Nepal', flag: '/flags/nepal.png', link:'https://columbiasportswear.com.np/columbia-hike-society' },
    { name: 'Hong Kong', flag: '/flags/hong_kong.png', link:'https://www.columbiasportswear.hk/news/hikesociety' },
    { name: 'India', flag: '/flags/india.png', link:'https://www.columbiasportswear.co.in/pages/columbia-hike-society' }
    
]);

const emea = ref([
    { name: 'South Africa', flag: '/flags/south_africa.png', link:' https://columbiasportswear.co.za'},
    

]);

</script>
